import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldControlMaster} from '../control-master-label-required';
import {FieldConfigName} from '../../../models';
import {FileInputDialogComponent} from './file-input-dialog.component';
import {Constants} from '../../common/constants';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileInputComponent extends FieldControlMaster implements OnInit {
  @Output() fileInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() fileInputDelete = new EventEmitter<number>();
  dialogComponent = FileInputDialogComponent;
  constants: any = Constants;
  selectedFile: File;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  handleFileInputChange(l: FileList): void {
    if (l.length) {
      this.selectedFile = (l[0].size < this.constants.maxSize) ? l[0] : null;
    }
  }

  onUpdatedControl(object) {
    const controlOptionsType = object.control.options;
    if (controlOptionsType.accept.length > 0) {
      controlOptionsType.acceptedTypeFile = [].concat(...controlOptionsType.accept);
    } else {
      /**
       * L'attribut accept du champ fichier ne dois jamais etre vide por raison sécurité.
       */
      controlOptionsType.acceptedTypeFile = 'image/*, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt';
    }
    this.fileInputUpdateControl.emit(object);
  }

  onDeletedControl(index: number) {
    this.fileInputDelete.emit(index);
  }
}
